// locales/it/index.ts
// Bulk import all files in a folder, eg: common.json, registration.json, etc.
// and export as an object: { common, registration, etc. }
const requireModule = require.context(".", false, /\.json$/);
const modules: any = {};

requireModule.keys().forEach((filename) => {
  const moduleName = filename.replace(/(\.\/|\.json)/g, "");
  modules[moduleName] = requireModule(filename);
});

export default modules;
